import React from 'react';
import { MktFooter } from '@securitize/reactjs-mkt-ui';
import { FooterLinkModel } from '../../data/builderio/footer/footer-link.model';
import { footerConstants } from '../../helpers/constants';
import secCredLogoNegative from '@securitize/assets-sec-ui/dist/logos/svg/sec-credit-logo-negative.svg';
import twitterIcon from '@securitize/assets-mkt-ui/dist/social/svg/twitter-social.svg';
import mediumIcon from '@securitize/assets-mkt-ui/dist/social/svg/medium-social.svg';

interface FooterProps {
  footerLinks: FooterLinkModel[];
}

export const Footer: React.FC<FooterProps> = ({ footerLinks }) => {
  const navigationLinks: any[] =
    footerLinks &&
    footerLinks?.map(({ data }: any, index) => {
      return {
        title: data.label,
        index,
        links: data.links?.map((link: any, index: number) => {
          return {
            label: link.label,
            url: link.url,
            index,
          };
        }),
      };
    });

  const socialLinks = [
    {
      icon: mediumIcon,
      url: 'https://medium.com/@securitizecredit',
      title: 'Medium',
    },
    {
      icon: twitterIcon,
      url: 'https://twitter.com/securitizecred',
      title: 'X',
    },
  ];

  return (
    <MktFooter
      navigationLinks={navigationLinks}
      showDisclaimer={false}
      footerLogo={secCredLogoNegative}
      showSocialAndAppStoreLinks={true}
      emailContact={footerConstants.EMAIL_CONTACT}
      copyrightInfo={footerConstants.COPYRIGHT}
      socialLinks={socialLinks}
    />
  );
};

export const MemoizedFooter = React.memo(Footer);
